/**
 * Preloaded post cards constants.
 */

export default {
    SET_POST_CARDS: 'SET_POST_CARDS',
    SET_IMAGE_BASE64: 'SET_IMAGE_BASE64',
};